// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__7q8lX","social":"Footer_social__xUQML"};